import { GetContractsQueryDto } from '@ekt-group/general-purpose-api-interfaces';
import { useQuery } from '@tanstack/react-query';

import { fetchFn } from '@/lib/react-query';

interface QueryParams extends GetContractsQueryDto {
  isContactsOutdated?: boolean;
  objectAddressIds?: number[];
}

const getContractsFn = <T>(params: QueryParams): Promise<T> =>
  fetchFn('/contracts', {
    params,
  });

export const useGetContracts = <T>(params: QueryParams) => {
  return useQuery<T>({
    queryKey: ['contracts', params],
    queryFn: () => getContractsFn(params),
  });
};
